import React from 'react';
import './PlayerPolicyIcon.css';
import {getPlayerHexColor} from "../../utils/players/getPlayerHexColor";
import {getPolicyImagePath} from "../../utils/policy/getPolicyImagePath";

const PlayerPolicyIcon = ({player, className, imgClassName, onClick}) => {
  const {
    policy
  } = player;

  if (!policy) {
    return null;
  }

  return (
    <div
      className={`player-faction-icon-container ${className}`}
      style={{
        background: getPlayerHexColor(player.color)
      }}
      onClick={onClick}
    >
      <img
        className={`player-faction-icon ${imgClassName}`}
        src={getPolicyImagePath(policy.id)}
        alt={policy.name}
        title={policy.name}
      />
    </div>
  );
};

export default PlayerPolicyIcon;